enum LeadFinderSubscriptionPlan {
  NONE = "no-plan",
  BASIC = "standard", // legacy
  PRO = "pro", // legacy
  STARTER = "starter",
  ADVANCED = "advanced",
  ELITE = "elite",
}

export const LEAD_FINDER_ENABLED_PLANS = [
  LeadFinderSubscriptionPlan.BASIC,
  LeadFinderSubscriptionPlan.PRO,
  LeadFinderSubscriptionPlan.STARTER,
  LeadFinderSubscriptionPlan.ADVANCED,
  LeadFinderSubscriptionPlan.ELITE,
];

// from basic to pro
export const LEAD_FINDER_PLAN_ORDER = [
  LeadFinderSubscriptionPlan.BASIC,
  LeadFinderSubscriptionPlan.PRO,
  LeadFinderSubscriptionPlan.STARTER,
  LeadFinderSubscriptionPlan.ADVANCED,
  LeadFinderSubscriptionPlan.ELITE,
] as const;

// the ones we should advertise
export const LEAD_FINDER_VALID_PLANS = [
  LeadFinderSubscriptionPlan.STARTER,
  LeadFinderSubscriptionPlan.ADVANCED,
  LeadFinderSubscriptionPlan.ELITE,
] as const;

export type UpgradeTargetPlan = (typeof LEAD_FINDER_VALID_PLANS)[number];

export const planToUpgradePlansMap: Record<LeadFinderSubscriptionPlan, UpgradeTargetPlan[]> = {
  [LeadFinderSubscriptionPlan.ADVANCED]: [LeadFinderSubscriptionPlan.ELITE],
  [LeadFinderSubscriptionPlan.BASIC]: [LeadFinderSubscriptionPlan.ELITE],
  [LeadFinderSubscriptionPlan.ELITE]: [],
  [LeadFinderSubscriptionPlan.NONE]: [
    LeadFinderSubscriptionPlan.STARTER,
    LeadFinderSubscriptionPlan.ADVANCED,
    LeadFinderSubscriptionPlan.ELITE,
  ],
  [LeadFinderSubscriptionPlan.PRO]: [LeadFinderSubscriptionPlan.ELITE],
  [LeadFinderSubscriptionPlan.STARTER]: [
    LeadFinderSubscriptionPlan.ADVANCED,
    LeadFinderSubscriptionPlan.ELITE,
  ],
};

export default LeadFinderSubscriptionPlan;
